module.exports = __webpack_public_path__ + "img/hat.6ef07357.png";